module.exports = __webpack_public_path__ + "public/images/lion.676ada808b8edff6b1efe768de4fe8e9.png";